module.exports = __webpack_public_path__ + "static/img/design-taste-no-axis.df8ac09a.svg";